import React from 'react';
import { Table as AntTable } from 'antd';
import PropTypes from 'prop-types';
import styles from './styles.module.css';

function Table(props) {
  return (
    <div className={styles.TableContainer}>
      <AntTable {...props} />
    </div>
  );
}

Table.defaultProps = {
  type: 'default',
};

Table.propTypes = {
  type: PropTypes.string,
};

export default Table;
